import api from './api';

export async function loginUser(email, password) {
  const response = await api.post('/account/login/password', { email, password });
  return response.data;
}

export async function forgotPassword(email) {
  const response = await api.post('/admin/forgot-password/send-otp', { email });
  return response.data;
}

export async function resetForgotPassword({ email, otp, password, confirmPassword }) {
  const response = await api.post('/admin/forgot-password/reset', {
    email,
    otp,
    password,
    confirmPassword,
  });
  return response.data;
}
